import React from 'react'
import { Link } from 'react-router-dom'
import { HeroCard } from 'common/styleguide/HeroCard'
import styles from './ZoneCard.scss'
import cx from 'classnames'

export const ZoneCard = ({ zone, countries, isMobile, namesI18n, cardHeight }) => {
  return (
    <div className={cx(styles.zoneCard, isMobile && styles.collapsed)}>
      <HeroCard
        title={namesI18n[zone]}
        img={`/images/regions/hero-${zone}.png`}
        img2x={`/images/regions/hero-${zone}@2x.png`}
        minHeight='135px'
        noPadding
      >
        <div className={styles.content} style={cardHeight && { height: cardHeight }}>
          {countries.map(country => (
            <Link className={styles.country} key={country} to={`/regions/${zone}/${country}`}>
              {namesI18n[country]}
            </Link>
          ))}
        </div>
      </HeroCard>
    </div>
  )
}
